import { useState } from "react";
import { getUser } from "../../../../helpers/utils";
import { useApp } from "../../../../helpers/app-context";
import { Page } from "../../../../components/Page";
import { Notification } from "../dashboard/components/Notification";
import { MarketingFunnel } from "./components/MarketingFunnel";
import { MarketingSummary } from "./components/MarketingSummary";
import { ChannelPerformance } from "./components/ChannelPerformance";
import { GuestReviewChart } from "./components/GuestReviewChart/GuestReviewChart";
import { FeederMarkets } from "./components/FeederMarkets/FeederMarkets";

export function Marketing({ user }) {
  const [isPriceAdjustmentModalOpen, setIsPriceAdjustmentModalOpen] =
    useState(false);
  const { isChatBotOpen } = useApp() as { isChatBotOpen: boolean };
  return (
    <>
      <div
        className={`py-5 flex-1 ${
          isChatBotOpen ? "w-[calc(100vw-350px)]" : ""
        } 1xl:w-[unset]`}
      >
        <div className="flex flex-col items-start  gap-5 mt-3.5 h-[calc(100vh-275px)]">
          <div className="w-full grow-[1] flex-1 flex flex-col md:flex-row gap-5">
            <div className="w-full md:w-auto flex-1">
              <MarketingSummary user={user} />
            </div>
            <div className="w-full md:w-auto flex-1">
              <MarketingFunnel user={user} />
            </div>
          </div>
          <div className="w-full grow-[1] flex-1 flex flex-col md:flex-row gap-5 pb-4 tall3XL:pb-0">
            <div className="w-full md:w-auto flex-1 max-h-[510px]">
              <ChannelPerformance user={user} />
            </div>
            <div className="w-full md:w-auto flex-1 flex flex-col md:flex-row gap-5">
              <div className="w-full md:w-auto flex-1 max-h-[510px]">
                <GuestReviewChart user={user} />
              </div>
              <div className="w-full md:w-auto flex-1 max-h-[510px]">
                <FeederMarkets user={user} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
